import { render, staticRenderFns } from "./AncillaryServiceTestsPage.vue?vue&type=template&id=b7ff3278&scoped=true"
import script from "./AncillaryServiceTestsPage.vue?vue&type=script&lang=js"
export * from "./AncillaryServiceTestsPage.vue?vue&type=script&lang=js"
import style0 from "./AncillaryServiceTestsPage.vue?vue&type=style&index=0&id=b7ff3278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ff3278",
  null
  
)

export default component.exports